import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import languageDetector from 'i18next-browser-languagedetector';

import Backend from 'i18n-backend';

import en from './locales/en.json';
import fr from './locales/fr.json';

i18n
      .use(languageDetector)
     .use(initReactI18next)
     .init({
        resources: { en: { translation : en}, fr: { translation : fr} },
        lng: 'en',
        fallbackLng: 'en',
        interpolation: { escapeValue: false}
     });

export default i18n;